module.exports = __webpack_public_path__ + "static/media/crime_scene.6690cae8.png";